import { ModelIcon } from "@hightouch/htui";

import { Icon as ContextIcon } from "src/components/layout/nav/icons/context";
import type { ComposerLeftAction } from "src/components/llm/components/composer-left-actions";

/** The composer's "+" menu row for picking Context Hub skills for the next message. */
export function skillsMenuItem({
  skills,
  selectedIds,
  isLoading,
  disabledTooltip,
  onToggle,
  onManage,
}: {
  skills: readonly { id: string; name: string }[];
  selectedIds: readonly string[];
  isLoading: boolean;
  /** Disables the row and says why, such as when there are no skills to pick. */
  disabledTooltip: string | undefined;
  onToggle: (id: string) => void;
  onManage: () => void;
}): ComposerLeftAction {
  return {
    key: "skills",
    label: "Skills",
    icon: ModelIcon,
    isLoading,
    isDisabled: disabledTooltip !== undefined,
    disabledTooltip,
    submenu: {
      items: skills.map((skill) => ({
        key: skill.id,
        label: skill.name,
        isChecked: selectedIds.includes(skill.id),
        onClick: () => onToggle(skill.id),
      })),
      footer: { label: "Manage skills", icon: ContextIcon, onClick: onManage },
    },
  };
}
